import { AssistantLayoutLoader } from './interviewLayoutInterface';

export function createAssistantLayoutLoader(): AssistantLayoutLoader {
    return {
        useLoad(context, props) {
            return {};
        },
    };
}
